import React from 'react';
import { Loader2, Brain, Sparkles } from 'lucide-react';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'brain' | 'sparkles';
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = '加载中...',
  size = 'md',
  variant = 'default',
  className = ''
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  const containerSizeClasses = {
    sm: 'p-4',
    md: 'p-8',
    lg: 'p-12'
  };

  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  };

  const renderIcon = () => {
    const iconClass = `${sizeClasses[size]} animate-spin`;
    
    switch (variant) {
      case 'brain':
        return <Brain className={`${iconClass} text-blue-600`} />;
      case 'sparkles':
        return <Sparkles className={`${iconClass} text-purple-600`} />;
      default:
        return <Loader2 className={`${iconClass} text-gray-600`} />;
    }
  };

  return (
    <div className={`flex flex-col items-center justify-center ${containerSizeClasses[size]} ${className}`}>
      <div className="mb-4">
        {renderIcon()}
      </div>
      {message && (
        <p className={`text-gray-600 text-center ${textSizeClasses[size]}`}>
          {message}
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;